export enum NoticeMarkup {
  PLAIN,
  HTML,
}

export interface Notice {
  success: (text: string, markup?: NoticeMarkup) => void;
  error: (errorOrText: string | Error | unknown, error?: Error | unknown, markup?: NoticeMarkup) => void;
  message: (text: string, type: string, markup?: NoticeMarkup) => void;
}
